import { createReducer, on } from "@ngrx/store";
import { GenericStoreApiData } from "src/components/shared-components/interfaces/generic-store-api-data";
import {
  environmentAccessControlStartInitAction,
  environmentAccessUserOpenableLoadErrorAction,
  environmentAccessUserOpenableLoadListFromApiAction,
  environmentAccessUserOpenableLoadSuccessAction,
  environmentAccessUserOpenableUnsetKeyStoreAction,
  environmentDeviceLoadErrorAction,
  environmentDeviceLoadInitStartAction,
  environmentDeviceLoadSuccessAction,
  environmentDeviceUnsetKeyStorageAction,
  environmentLoadErrorAction,
  environmentLoadInitStartAction,
  environmentLoadSuccessAction,
  environmentUnsetKeyStorageAction,
  environmetAccessControlLoadErrorAction,
  environmetAccessControlLoadSuccessAction,
} from "../actions/environment.actions";

/**
 * Initial state of areas store
 */
const initialState: GenericStoreApiData = {
  loaded: false,
  errorGeneric: false,
  errorNotYetImplemented: false,
  isOldDataInUse: false,
  data: null,
};

//#region Environment
/**
 * Reducer for environment
 */
export const EnvironmentReducer = createReducer(
  initialState,
  on(
    environmentUnsetKeyStorageAction,
    (environmentObject: GenericStoreApiData, action) => {
      return initialState;
    }
  ),
  on(
    environmentLoadInitStartAction,
    (environmentObject: GenericStoreApiData, action) => {
      return { ...environmentObject, loaded: false };
    }
  ),
  on(
    environmentLoadSuccessAction,
    (environmentObject: GenericStoreApiData, action) => {
      return {
        loaded: true,
        errorGeneric: false,
        errorNotYetImplemented: false,
        isOldDataInUse: false,
        data: action.environmentObject,
      };
    }
  ),
  on(
    environmentLoadErrorAction,
    (environmentObject: GenericStoreApiData, action) => {
      return {
        loaded: true,
        errorGeneric: true,
        errorNotYetImplemented: false,
        isOldDataInUse: false,
        data: null,
      };
    }
  )
);
//#endregion

//#region Environment device
/**
 * Reducer for environment device
 */
export const EnvironmentDeviceReducer = createReducer(
  initialState,
  on(
    environmentDeviceUnsetKeyStorageAction,
    (environmentDeviceObject: GenericStoreApiData, action) => {
      return initialState;
    }
  ),
  on(
    environmentDeviceLoadInitStartAction,
    (environmentObject: GenericStoreApiData, action) => {
      return { ...environmentObject, loaded: false };
    }
  ),
  on(
    environmentDeviceLoadSuccessAction,
    (environmentObject: GenericStoreApiData, action) => {
      return {
        loaded: true,
        errorGeneric: false,
        errorNotYetImplemented: false,
        isOldDataInUse: false,
        data: action.environmentObject,
      };
    }
  ),
  on(
    environmentDeviceLoadErrorAction,
    (environmentObject: GenericStoreApiData, action) => {
      return {
        loaded: true,
        errorGeneric: true,
        errorNotYetImplemented: false,
        isOldDataInUse: false,
        data: null,
      };
    }
  )
);
//#endregion

//#region Environment User access openable
/**
 * Reducer for environment user access openable
 */
export const EnvironmentUserAccessOpenableReducer = createReducer(
  initialState,
  on(
    environmentAccessUserOpenableUnsetKeyStoreAction,
    (environmentUserAccessOpenabledObject: GenericStoreApiData, action) => {
      return initialState;
    }
  ),
  on(
    environmentAccessUserOpenableLoadListFromApiAction,
    (environmentUserAccessOpenabledObject: GenericStoreApiData, action) => {
      return { ...environmentUserAccessOpenabledObject, loaded: false };
    }
  ),
  on(
    environmentAccessUserOpenableLoadSuccessAction,
    (environmentUserAccessOpenabledObject: GenericStoreApiData, action) => {
      return {
        loaded: true,
        errorGeneric: false,
        errorNotYetImplemented: false,
        isOldDataInUse: false,
        data: action.listEnvironmentOpenDoorCommandObject,
      };
    }
  ),
  on(
    environmentAccessUserOpenableLoadErrorAction,
    (environmentUserAccessOpenabledObject: GenericStoreApiData, action) => {
      return {
        loaded: true,
        errorGeneric: true,
        errorNotYetImplemented: false,
        isOldDataInUse: false,
        data: null,
      };
    }
  )
);
//#endregion

//#region  Environment Access Control
/**
 * Reducer for environment access control
 */
export const EnvironmentAccessControlMaintananceReducer = createReducer(
  initialState,
  on(
    environmentAccessControlStartInitAction,
    (environmentAccessControlObject: GenericStoreApiData, action) => {
      return { ...environmentAccessControlObject, loaded: false };
    }
  ),
  on(
    environmetAccessControlLoadSuccessAction,
    (environmentObject: GenericStoreApiData, action) => {
      return {
        loaded: true,
        errorGeneric: false,
        errorNotYetImplemented: false,
        isOldDataInUse: false,
        data: action.listEnvironmentAccessControlMaitanance,
      };
    }
  ),
  on(
    environmetAccessControlLoadErrorAction,
    (environmentObject: GenericStoreApiData, action) => {
      return {
        loaded: true,
        errorGeneric: true,
        errorNotYetImplemented: false,
        isOldDataInUse: false,
        data: null,
      };
    }
  )
);
//#endregion
